import GraphQL from '@app/model/_common/service/GraphQL';
import {
	MARKET_STATE_DAILY_SNAPSHOT_FRAGMENT,
	MARKET_STATE_DAILY_SNAPSHOT_WITH_COMPARISON_FRAGMENT,
	MARKET_STATE_FOR_DAY_NOTIFICATIONS, PRICE_RECOMMENDATION_STATE_FRAGMENT,
} from '@app/model/market_state/service/MarketStateGraphQLFragments';
import { gql } from 'graphql-request';
import {
	PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT
} from '@app/model/process-request/service/ProcessRequestGraphQLFragments';

export const TRIGGER_MARKET_STATE_UPDATE_MUTATION: GraphQL = {
	name: 'triggerMarketStateUpdate',
	gql: gql`
			${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
      mutation triggerMarketStateUpdate($companyHotelId: Long!, $year: Int!, $month: Month!, $numberOfMonths: Int!, $filterInput: MarketStateFilterInput!, $withOta: Boolean!, $withProof: Boolean!) {
          triggerMarketStateUpdate(companyHotelId: $companyHotelId, year:$year, month:$month, numberOfMonths:$numberOfMonths, filterInput:$filterInput, withOta:$withOta, withProof:$withProof) {
              ...ProcessRequestExecutionStateFields
          }
      }
	`,
};

export const FIND_MARKET_STATE_FOR_DAY_QUERY: GraphQL = {
	name: 'findMarketStateForDay',
	gql: gql`
      ${MARKET_STATE_DAILY_SNAPSHOT_WITH_COMPARISON_FRAGMENT}
      query findMarketStateForDay($companyHotelId: Long!, $statDate: LocalDate!, $filterInput:MarketStateFilterInput!) {
          findMarketStateForDay(companyHotelId: $companyHotelId, statDate: $statDate, filterInput: $filterInput) {
              ...MarketStateDailySnapshotWithComparisonOutputFragment
          }
      }
	`,
};


export const FIND_PREVIOUS_MARKET_STATE_FOR_DAY_QUERY: GraphQL = {
	name: 'findPreviousMarketStateForDay',
	gql: gql`
      ${MARKET_STATE_DAILY_SNAPSHOT_FRAGMENT}
      query findPreviousMarketStateForDay($companyHotelId: Long!, $statDate: LocalDate!, $filterInput:MarketStateFilterInput!, $fromDate: LocalDateTime!) {
          findPreviousMarketStateForDay(companyHotelId: $companyHotelId, statDate: $statDate, filterInput: $filterInput, fromDate: $fromDate) {
              ...MarketStateDailySnapshotFields
          }
      }
	`,
};


export const FIND_MARKET_STATE_FOR_PERIOD_QUERY: GraphQL = {
	name: 'findMarketStateForPeriod',
	gql: gql`
      ${MARKET_STATE_DAILY_SNAPSHOT_WITH_COMPARISON_FRAGMENT}
      query findMarketStateForPeriod($companyHotelId: Long!, $year:Int!, $month:Month!, $startStatDate:LocalDate, $endStatDate:LocalDate, $filterInput:MarketStateFilterInput!) {
          findMarketStateForPeriod(companyHotelId: $companyHotelId, year: $year, month:$month, startStatDate: $startStatDate, endStatDate: $endStatDate, filterInput: $filterInput) {
              companyHotelId
              latestUpdateDate
              latestUpdateDatePerMonth {
                  lastUpdateDate
                  month
              }
              latestRecommendationRunDate
              dailySnapshots {
                  ...MarketStateDailySnapshotWithComparisonOutputFragment
              }
          }
      }
	`,
};
export const MARK_ALERT_NOTIFICATION_AS_READ_MUTATION: GraphQL = {
	name: 'markAlertExecutionNotificationAsRead',
	gql: gql`
      mutation markAlertExecutionNotificationAsRead($companyHotelId: Long!,$notificationId: Long!) {
          markAlertExecutionNotificationAsRead(companyHotelId: $companyHotelId, notificationId: $notificationId) {
              success
              exception
          }
      }
	`,
};

export const FIND_MARKET_STATE_DAY_PRICE_EVOLUTION_FOR_HISTORY_QUERY: GraphQL = {
	name: 'findMarketStateDayPriceEvolutionForHistory',
	gql: gql`
      ${MARKET_STATE_DAILY_SNAPSHOT_FRAGMENT}
      query findMarketStateDayPriceEvolutionForHistory($companyHotelId: Long!, $statDate: LocalDate!, $filterInput:MarketStateFilterInput!) {
          findMarketStateDayPriceEvolutionForHistory(companyHotelId: $companyHotelId, statDate: $statDate, filterInput: $filterInput) {
              ...MarketStateDailySnapshotFields
          }
      }
	`,
};

export const FIND_MARKET_STATE_DAY_PRICE_EVOLUTION_FOR_TIMEFRAME_QUERY: GraphQL = {
	name: 'findMarketStateDayPriceEvolutionForTimeframe',
	gql: gql`
      ${MARKET_STATE_DAILY_SNAPSHOT_FRAGMENT}
      query findMarketStateDayPriceEvolutionForTimeframe($companyHotelId: Long!, $statDate: LocalDate!, $filterInput:MarketStateFilterInput!) {
          findMarketStateDayPriceEvolutionForTimeframe(companyHotelId: $companyHotelId, statDate: $statDate, filterInput: $filterInput) {
              ...MarketStateDailySnapshotFields
          }
      }
	`,
};

export const FIND_ALERT_EXECUTION_NOTIFICATIONS_FOR_PERIOD: GraphQL = {
	name: 'findAlertExecutionNotificationsForPeriod',
	gql: gql`
      ${MARKET_STATE_FOR_DAY_NOTIFICATIONS}
      query findAlertExecutionNotificationsForPeriod($companyHotelId: Long!, $startStatDate: LocalDate!, $endStatDate: LocalDate!) {
          findAlertExecutionNotificationsForPeriod(companyHotelId: $companyHotelId, startStatDate: $startStatDate, endStatDate: $endStatDate) {
              ...MarketStateForDayNotificationsFragment
          }
      }
	`,
};

export const FIND_COMPANY_HOTEL_AVAILABILITY_WITH_COMPARISON_QUERY: GraphQL = {
	name: 'findCompanyHotelAvailabilityWithComparison',
	gql: gql`
      query findCompanyHotelAvailabilityWithComparison($companyHotelId: Long!, $statDate: LocalDate!) {
          findCompanyHotelAvailabilityWithComparison(companyHotelId: $companyHotelId, statDate: $statDate) {
              statDate
              current {
                  statDate
                  creationDate
                  items {
                      availability
                      hotelId
                      roomName
                  }
              }
              previous {
                  statDate
                  creationDate
                  items {
                      availability
                      hotelId
                      roomName
                  }
              }
          }
      }
	`,
};

export const CONSTRUCT_MARKET_STATE_ITEM_URL_QUERY: GraphQL = {
	name: 'constructMarketStateItemUrl',
	gql: gql`
      query constructMarketStateItemUrl($marketStateItemId: Long!, $marketStateIds:[Long]!) {
          constructMarketStateItemUrl(marketStateItemId: $marketStateItemId, marketStateIds: $marketStateIds)
      }
	`,
};

export const TRIGGER_PRICE_RECOMMENDATION_UPDATE_MUTATION: GraphQL = {
	name: 'triggerPriceRecommendationUpdate',
	gql: gql`
			${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
      mutation triggerPriceRecommendationUpdate($companyHotelId: Long!, $year: Int!, $month: Month!) {
          triggerPriceRecommendationUpdate(companyHotelId: $companyHotelId, year: $year, month: $month) {
              ...ProcessRequestExecutionStateFields
          }
      }
	`,
};
export const TRIGGER_PRICE_RECOMMENDATION_LITE_UPDATE_MUTATION: GraphQL = {
	name: 'triggerPriceRecommendationLiteUpdate',
	gql: gql`
      ${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
      mutation triggerPriceRecommendationLiteUpdate($companyHotelId: Long!, $year: Int!, $month: Month!) {
          triggerPriceRecommendationLiteUpdate(companyHotelId: $companyHotelId, year: $year, month: $month) {
              ...ProcessRequestExecutionStateFields
          }
      }
	`,
};

export const FIND_LATEST_PRICE_RECOMMENDATION_STATES_FOR_STAT_DATE_QUERY: GraphQL = {
	name: 'findLatestPriceRecommendationStateForStatDate',
	gql: gql`
      ${PRICE_RECOMMENDATION_STATE_FRAGMENT}
      query findLatestPriceRecommendationStateForStatDate($companyHotelId: Long!, $statDate: LocalDate!) {
          findLatestPriceRecommendationStateForStatDate(companyHotelId: $companyHotelId, statDate: $statDate) {
              ...PriceRecommendationStateFragment
          }
      }
	`
}

export const FIND_COMPANY_HOTEL_PRICE_RECOMMENDATION_STATE_QUERY: GraphQL = {
	name: 'findCompanyHotelPriceRecommendationState',
	gql: gql`
      ${PRICE_RECOMMENDATION_STATE_FRAGMENT}
      query findCompanyHotelPriceRecommendationState($companyHotelId: Long!, $recommendationStateId: Long!) {
          findCompanyHotelPriceRecommendationState(companyHotelId: $companyHotelId, recommendationStateId: $recommendationStateId) {
              ...PriceRecommendationStateFragment
          }
      }
	`
}


